"use client";
import React from "react";
export default function PTEELAFT() {
  const pdfUrl = require("../../assets/static/POLITICA PTEE-LA_FT_FPADM.pdf");
  return (
    <section style={{ width: "100%", height: "100vh",backgroundColor:"#121212" }}>
      <div style={{position:"relative",marginTop:"100px"}}>
      </div>
      <iframe
        src={pdfUrl}
        title="Política PTEE-LA/FT-FPADM"
        width="100%"
        height="100%"
        contentEditable={false}
      />
    </section>
  );
}